import { c as _c } from "react/compiler-runtime";
import React from 'react';
import BVReviews from './BVReviews';
import useBvReviewsForceMount from './useBvReviewsForceMount';
import usePdpFullVariantSku from '../state/pdpFullVariantSku/usePdpFullVariantSku';

// Mount point for BV reviews when PDPCustomerPhotos is omitted (edit-order PDP).
// Rating summary still renders and can fire swat_reviews 'show'.
const BVReviewsOnShowHost = () => {
  const $ = _c(2);
  const variantSku = usePdpFullVariantSku();
  const forceMountReviews = useBvReviewsForceMount();
  if (!forceMountReviews || !variantSku) {
    return null;
  }
  let t0;
  if ($[0] !== variantSku) {
    t0 = <div className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 min-h-[400px]" id="PDPCustomerPhotos"><BVReviews key={variantSku} productId={variantSku} /></div>;
    $[0] = variantSku;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default BVReviewsOnShowHost;